import angular from 'angular';
import uiRouter from 'angular-ui-router';
import jobDetailsComponent from './job-details.component';

let jobDetailsModule = angular.module('app.containers.job-details', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('jobDetails', {
      url: '/jobs/:jobId',
      template: '<job-details></job-details>'
    });
})

.component('jobDetails', jobDetailsComponent);

export default jobDetailsModule;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/job-details/job-details.js
 **/